import axios from "axios";
// export default axios.defaults.baseURL = "https://consultancy-api.iid.org.in"
// export const baseURL     = "http://localhost:3001"
// export const baseURL = "http://192.168.1.10:3000/"
// export const socketUrl = baseURL;
export const baseURL = "https://phedrserverapi.consoletrack.com"
// export const docUrl = "https://phedrserver.asginnovations.in/uploads/uploads"
export const docUrl = "https://phed.s3.ap-south-1.amazonaws.com"
export const socketUrl = "https://phedrserverapi.consoletrack.com"
// export const socketUrl = "http://localhost:3001"
export default axios.defaults.baseURL = baseURL;